import SelectCandidatesListContainer from './select_candidates_list_container';

const SelectCandidatesList = SelectCandidatesListContainer;
export default SelectCandidatesList;
